import React, { useEffect, useState } from 'react'
import Sidebaar from '../Components/Sidebar'
import { Form, FormGroup } from "react-bootstrap"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify';
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import { BaseUrl } from '../Url'
import Switch from "react-switch";

import Loader from '../Components/Loader';

function Category() {
    const [loading, setloading] = useState(false)
    const [checked, setChecked] = useState(false);

    let token = localStorage.getItem("token")
    const [title, settitle] = useState("")
    const [description, setdescription] = useState("")
    const [data, setdata] = useState([])
    const [editid, seteditid] = useState("")
    const [file, setfile] = useState("")
    // const token = localStorage.getItem("token")
    // const headers = {
    //     Authorization: `Bearer ${token}`
    // }
    const getRowId = (row) => row._id
    const handleSubmit = (e) => {
        e.preventDefault()
        setloading(true)
        let requestdata = {
            title: title,
            description: description,
        }
        axios.post(`${BaseUrl}/category`, requestdata).then((res) => {
            // console.log("Res", res)
            if (res.data.is_success == "1") {
                // toast.success("Data Submitted Successfully")
                handleclear()
                handleget()
                handleimgagesubmit(res.data.data._id)
            }

        }).finally(() => {
            setloading(false)
        })
    }

    const headers = {
        Authorization: `Bearer ${token}`
    }

    const handleupdate = (e) => {
        e.preventDefault()
        setloading(true)

        let formdata = new FormData()

        formdata.append("title", title)
        formdata.append("description", description)
        if (file) {
            formdata.append("icon", file)
        }



        axios.put(`${BaseUrl}/category/update/${editid}`, formdata, { headers }).then((res) => {

            if (res.data.success == "1") {

                toast.success("Data Update Successfully")
                handleclear()
                handleget()
                seteditid("")
            }

        }).finally(() => {
            setloading(false)
        })
    }


    const handleChange = (checked, id) => {
        console.log("od", id)
        setChecked(checked);
        setloading(true)
        let requestData = {
            coming_soon: checked
        }
        axios.put(`${BaseUrl}/category/update/${id}`, requestData, { headers }).then((res) => {
            if (res.data.success == 1) {
                console.log("ress", res.data)
                toast.success("Succesffully Update")
                handleget()
            }
        }).finally(() => {
            setloading(false)

        })
    };




    const handleimgagesubmit = (imageid) => {
        let formdata = new FormData()
        formdata.append("category_id", imageid)
        formdata.append("icon", file)
        axios.post(`${BaseUrl}/category/set-icon`, formdata).then((res) => {
            if (res.data.is_success == "1") {
                toast.success("Data Submit Succesffully")
            }
        })
    }


    const handleclear = () => {
        settitle("")
        setdescription("")
    }
    const handleget = (e) => {
        axios.get(`${BaseUrl}/category`).then((res) => {
            setdata(res.data.data)
        })
    }
    useEffect(() => {
        handleget()
    }, [])
    const columns = [
        {
            field: "title",
            headerName: "Title",
            flex: 1,

        },
        {
            field: "description",
            headerName: "Description",
            flex: 1,

        },
        {
            field: "edit",
            headerName: "Edit",
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <button className='btn custombtn' onClick={(e) => handleedit(params.row)}><i className="fa-solid fa-pen-to-square"></i></button>
                    </>
                )
            }

        },
        {
            field: "toggle",
            headerName: "Coming Soon",
            flex: 1,
            renderCell: (params) => {
                // Calculate the bidding price by multiplying quantity with subcategory rate

                return (
                    <>
                        <label>
                            <Switch
                                onChange={(checked) => handleChange(checked, params.row._id)}
                                checked={params.row.coming_soon}
                            />
                        </label>
                    </>
                );
            },
        },
        {
            field: "delete",
            headerName: "Delete",
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <button className='btn custombtn' onClick={(e) => handledelete(params.row)}><i className="fa-solid fa-trash"></i></button>
                    </>
                )
            }

        }
    ]

    const handleedit = (editdata) => {
        console.log(editid)
        seteditid(editdata._id)
        settitle(editdata.title)
        setdescription(editdata.description)
    }

    const handlefile = (e) => {
        let selectedfile = e.target.files[0]
        setfile(selectedfile)
    }

    // const handledelete = (del) => {
    //      // console.log("delet", del._id)
    //     let requestdata = {
    //         id: del._id
    //     }

    //     axios.delete(`${BaseUrl}/category/destroy`, requestdata).then((res) => {
    //         if (res.data.is_success == "1") {
    //             toast.success("Deleted Succesffully")
    //             handleget()
    //         }
    //     })

    // }
    const handledelete = (del) => {
        setloading(true)
        let requestData = {
            data: {
                id: del._id
            }
        };

        axios.delete(`${BaseUrl}/category/destroy`, requestData)
            .then((res) => {
                // console.log("ress", res)
                if (res.data.is_success == "1") {
                    toast.success("Deleted Successfully");
                    handleget(); // Assuming handleGet is defined elsewhere to refresh the category list
                }
            })
            .catch((error) => {
                console.error("Error deleting category:", error);
            }).finally(() => {
                setloading(false)
            })
    };



    return (
        <>
            {loading &&
                <Loader />
            }
            <ToastContainer />
            <Sidebaar content={<>
                <section>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="text-center">
                                    <h3>Category</h3>
                                </div>
                            </div>

                        </div>
                        <Form onSubmit={(e) => editid ? handleupdate(e) : handleSubmit(e)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <FormGroup>
                                        <label htmlFor="">Title</label>
                                        <input type="text" value={title} onChange={(e) => settitle(e.target.value)} className='form-control' />
                                    </FormGroup>
                                </div>

                                <div className="col-md-4">
                                    <FormGroup>
                                        <label htmlFor="">Description</label>
                                        <input type="text" value={description} onChange={(e) => setdescription(e.target.value)} className='form-control' />
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup>
                                        <label htmlFor="">Image</label>
                                        <input type="file" onChange={(e) => handlefile(e)} className='form-control' />
                                    </FormGroup>
                                </div>

                                <div className="col-md-4">
                                    <button className='btn mt-3 bg-green text-white'>Submit</button>
                                </div>

                            </div>
                        </Form>
                        <div className="row mt-3 tableview">
                            <div className="col-md-12">
                                <Box sx={{ height: 500, width: "100%" }}>
                                    <DataGrid
                                        rows={data}
                                        columns={columns}
                                        pageSize={5}
                                        getRowId={getRowId}
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 10 } },
                                        }}
                                        pageSizeOptions={[5, 10, 25]}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                </section>
            </>} />
        </>
    )
}

export default Category
